<template>
  <div id="login-page">
    <transition appear appear-active-class="animated bounceInDown" v-on:enter="onEnterForm">
      <b-form class="card" v-on:submit.prevent="onSubmit">
        <div class="card-header">
          <strong>Login</strong>
        </div>
        <div class="card-body">
          <b-alert
            :show="loginAlert.show"
            :variant="loginAlert.type"
            @dismissed="onCloseAlert"
            dismissible
            fade>
            <strong v-if="loginAlert.strong">{{ loginAlert.strong }}</strong>
            {{ loginAlert.message }}
          </b-alert>

          <b-form-group label="User :" label-for="input-user-login" :label-sr-only="!inputUsernameShow">
            <transition name="slide-fade-input" v-on:enter="afterEnterInputUsername">
              <b-form-input
                type="text"
                name="username"
                id="input-user-login"
                placeholder="User ID"
                v-show="inputUsernameShow"
                v-model="form.username"
                :disabled="loading"
                required>
              </b-form-input>
            </transition>
          </b-form-group>

          <b-form-group label="Password :" label-for="input-password-login" :label-sr-only="!inputPasswordShow">
            <transition name="slide-fade-input">
              <b-form-input
                type="password"
                name="password"
                placeholder="Enter your password"
                id="input-password-login"
                v-show="inputPasswordShow"
                v-model="form.password"
                :disabled="loading"
                required>
              </b-form-input>
            </transition>
          </b-form-group>
        </div>
        <div class="card-footer">
          <b-btn type="submit" :disabled="loading">
            <font-awesome-icon :icon="iconButtonSubmit"
              :spin="loading" /> Login
          </b-btn>
        </div>
      </b-form>
    </transition>
  </div>
</template>

<style type="scss">
  .slide-fade-input-enter-active {
    transition: all .6s ease;
  }
  .slide-fade-input-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-input-enter, .slide-fade-input-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>

<script>

  export default {
    data () {
      return {
        loading: true,
        inputUsernameShow: false,
        inputPasswordShow: false,
        alert: {
          type: 'danger',
          show: false
        },
        form: {
          username: null,
          password: null,
          submitted: false
        }
      };
    },
    mounted() {
      this.loading = false
    },
    computed: {
      authentication() {
        return this.$store.state.authentication
      },
      loginMessage() {
        return this.authentication.loginMessage
      },
      iconButtonSubmit() {
        return true === this.loading ? 'sync-alt' : 'sign-in-alt'
      },
      loginAlert() {
        const message = this.authentication.loginMessage
        const contex = {
          message: message,
          show: ( message && message.length )
        }

        Object.assign(this.alert, contex)
        return this.alert
      }
    },
    methods: {
      onCloseAlert() {
        this.$store.dispatch( 'authentication/setLoginMessage', null )
        this.alert.show = false
      },
      onSubmit( event ) {
        if ( event && event.preventDefault ) {
          event.preventDefault();
        }

        this.loading = true

        const { username, password } = this.form
        const { dispatch } = this.$store
        if ( username && password ) {
          return dispatch( 'authentication/login', { username, password } ).then( response => {
            const data = response.data
            if ( data.token ) {
              this.$router.push('/')
            }
            else {
              this.loading = false
            }
          } ).catch( () => {
            this.loading = false
            this.alert.show = true
          } )
        }
      },
      onEnterForm() {
        setTimeout( () => {
          this.inputUsernameShow = true
        }, 400 )
      },
      afterEnterInputUsername() {
        setTimeout( () => {
          this.inputPasswordShow = true
        }, 200 )
      }
    }
  };
</script>